if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.productInput = this.form.querySelector('[name=product_id]');
        this.variantInput = this.form.querySelector('[name=id]');
        this.sizePositionInput = this.form.querySelector('[name=size_position]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.isWholesaleCustomer =
          this.dataset.wholesaleCustomer === 'true' || this.submitButton.getAttribute('data-company') === 'true';
        this.showingRoomingErrorActive = false;
        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async getCartData() {
        const response = await fetch("/cart.json");

        const data = await response.json();
        return data;
      }

      showShowroomError() {
        this.showingRoomingErrorActive = true
        const errorDiv = document.createElement('div');
        errorDiv.classList.add('showroom-error');
        errorDiv.innerHTML = window.showingRoomingErroText;
        this.form.after(errorDiv);
        
        setTimeout(() => {
          const errorBox = document.querySelector('.showroom-error')
          if (errorBox){
            errorBox.remove();
          }
          this.showingRoomingErrorActive = false
        }, 5000);
      }

      checkForShowrooming(cartData) {
        
        const variantData = JSON.parse(document.querySelector('variant-selects script[type="application/json"][data-all-variants]').textContent)
        console.log(variantData);

        const thisItem = variantData.find((object) => object.id === Number(this.variantInput.value));
        const optionNumer = `option${Number(this.sizePositionInput.value) + 1}`;

        const matchedItems = cartData.items.filter((object) => object.product_id === Number(this.productInput.value));
        console.log(matchedItems);
        if(matchedItems.length){
          
          if (matchedItems[0].variant_options[Number(this.sizePositionInput.value)] != thisItem[optionNumer]){
            if (matchedItems[0].variant_options.length > 1) {
              if (matchedItems[0].variant_options[Number(this.sizePositionInput.value) - 1] != thisItem[optionNumer - 1]){
                return true
              }
            } else {
              return true
            }
          }
        }
        return false
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        
        if (this.sizePositionInput && !this.isWholesaleCustomer) {
          const cartData = await this.getCartData();
          
          if (this.checkForShowrooming(cartData) === true) {
            if (this.showingRoomingErrorActive === false) {
              this.showShowroomError();
            }
            
            return false
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
